<!-- Mobile Top Bar with Hamburger -->
<header class="mobile-topbar">
  <div class="mobile-brand">
    <img class="brand-logo" src="scb-logo-white.svg" alt="Science Centre Singapore" />
    <span class="mobile-brand-title">Science Centre SG</span>
  </div>
  <button type="button" class="mobile-menu-toggle" (click)="toggleMobileMenu()" [attr.aria-label]="mobileMenuOpen ? 'Close Menu' : 'Open Menu'">
    @if (mobileMenuOpen) {
      <span class="toggle-icon">✕</span>
    } @else {
      <span class="toggle-icon">☰</span>
    }
  </button>
</header>

<!-- Backdrop overlay for mobile drawer -->
@if (mobileMenuOpen) {
  <div class="mobile-backdrop" (click)="closeMobileMenu()"></div>
}

<aside class="sidebar" [class.open]="mobileMenuOpen">
  <!-- Brand Identity (Desktop / Tablet) -->
  <div class="brand">
    <img class="brand-logo" src="scb-logo-white.svg" alt="Science Centre Singapore" />
    <div>
      <div class="brand-name">Science Centre SG</div>
      <div class="brand-sub">CRM Admin Console</div>
    </div>
    <button type="button" class="mobile-close-btn" (click)="closeMobileMenu()">✕</button>
  </div>

  <!-- Role-based Navigation Links -->
  <nav class="nav-menu">
    @for (l of links; track l.path) {
      <a [routerLink]="l.path" routerLinkActive="active" (click)="closeMobileMenu()" class="nav-item" [attr.data-id]="l.path">
        <span class="ico">
          @switch (l.icon) {
            @case ('dashboard') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="7" height="9" x="3" y="3" rx="1"/><rect width="7" height="5" x="14" y="3" rx="1"/><rect width="7" height="9" x="14" y="12" rx="1"/><rect width="7" height="5" x="3" y="16" rx="1"/></svg>
            }
            @case ('visitors') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            }
            @case ('rewards') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
            }
            @case ('audit') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/><path d="m9 12 2 2 4-4"/></svg>
            }
            @case ('activations') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="5" height="5" x="3" y="3" rx="1"/><rect width="5" height="5" x="16" y="3" rx="1"/><rect width="5" height="5" x="3" y="16" rx="1"/><path d="M21 16h-3a2 2 0 0 0-2 2v3"/><path d="M21 21v.01"/><path d="M12 7v3a2 2 0 0 1-2 2H7"/><path d="M3 12h.01"/><path d="M12 3h.01"/><path d="M12 16v.01"/><path d="M16 12h1"/><path d="M21 12v.01"/><path d="M12 21v-1"/></svg>
            }
            @case ('push') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>
            }
            @case ('content') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
            }
            @case ('app-info') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
            }
            @case ('legal') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/><path d="m9 12 2 2 4-4"/></svg>
            }
            @case ('users') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            }
            @case ('roles') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            }
            @case ('ota') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"/><path d="M12 12v9"/><path d="m16 16-4-4-4 4"/></svg>
            }
            @default {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/></svg>
            }
          }
        </span>
        <span class="label">{{ l.label }}</span>
      </a>
    }
  </nav>

  <div class="spacer"></div>

  <!-- Visitor App Quick Link -->
  <a class="visitor-app-link" [attr.href]="visitorAppUrl" target="_blank" rel="noopener">
    <span class="ico">↗</span>
    <span>Open visitor app</span>
  </a>

  <!-- Authenticated User Profile Summary -->
  <div class="user-box">
    <div class="avatar" [style.background]="roleColor">{{ initials }}</div>
    <div class="user-meta">
      <div class="user-name" [title]="name">{{ name }}</div>
      <div class="user-email mono" [title]="email">{{ email }}</div>
      <div class="user-role-badge" [style.color]="roleColor">{{ roleBadge }}</div>
    </div>
  </div>

  <!-- Sign Out Action -->
  <button type="button" class="logout" (click)="logout()">Sign out</button>
</aside>
